// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-pages----index-module---hero---nkUhx","features":"src-pages----index-module---features---1Pthj","feature":"src-pages----index-module---feature---2x5dX","featureExample":"src-pages----index-module---featureExample---2wkS7","gettingStarted":"src-pages----index-module---gettingStarted---34DAa"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.scss
// module id = 559
// module chunks = 35783957827783